import { useContext } from 'react';
import { ModalContext } from 'providers/ModalProvider';
import type { ContextProps } from 'providers/ModalProvider';

export function useModal(): ContextProps {
  const { openModal, closeModal } = useContext(ModalContext);

  return { openModal, closeModal };
}
